import { appData } from '@/mocks/chiguaHomeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-[320px] lg:max-w-[360px]">
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src={appData.image}
                alt="吃瓜在线移动端界面"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 rounded-3xl ring-1 ring-inset ring-foreground-900/10"></div>
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-6 leading-relaxed">
              {appData.subtitle}
            </p>

            <div className="grid grid-cols-2 gap-3 mb-8 max-w-md mx-auto lg:mx-0">
              {appData.features.map((feat, i) => (
                <div key={i} className="flex items-center gap-2 p-3 rounded-lg bg-background-100">
                  <i className="ri-check-line text-primary-500 text-sm"></i>
                  <span className="text-sm text-foreground-700 whitespace-nowrap">{feat}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line"></i>
                iOS 下载
              </a>
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line"></i>
                Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}